import { Group, Plus } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "shared/components";
import { Flex } from "styled-system/jsx";
import {
  EnumEntityReferenceType,
  useOrganizationStaffQuery,
} from "gql/generated";
import { StaffPageContent } from "shared/components";
import { useParams } from "react-router-dom";
import { useState } from "react";

export const Staff = () => {
  const { t } = useTranslation();

  const { organizationId: _entityId } = useParams();

  const [inviteStaffModalClickHandler, setInviteStaffModalClickHandler] =
    useState<{
      trigger: () => void;
    }>();

  return (
    <>
      <Flex flexDir={"column"} gap={"500"}>
        <PageHeader
          title={t("core:STAFF.TITLE")}
          Icon={Group}
          ctaButtonCopy={t("core:STAFF.CTA_BUTTON.INVITE")}
          ctaButtonProps={{
            Icon: Plus,
            onClick: inviteStaffModalClickHandler?.trigger,
          }}
        />
        <StaffPageContent
          _entityId={_entityId ?? ""}
          type={EnumEntityReferenceType.Organization}
          setInviteStaffModalClickHandler={setInviteStaffModalClickHandler}
          staffGetter={useOrganizationStaffQuery}
        />
      </Flex>
    </>
  );
};
